import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { GeneralService } from '../../../services/formulacion/general.service';
import { TraspasoService } from '../../../services/formulacion/traspaso.service';
import { environment } from '../../../../environments/environment';
import { UtilHelper } from '../../../_helpers/util';
import { FuenteService } from '../../../services/formulacion/fuente.service';
import { OrganismoService, PoaTechoService } from 'src/app/services/service.index';
declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-traspasos-aprobar',
  templateUrl: './traspasos-aprobar.component.html',
  styleUrls: [],
  providers: [GeneralService, TraspasoService]
})
export class TraspasosAprobarComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @ViewChild(DxScrollViewComponent) scrollView: DxScrollViewComponent;
  verListaObs: boolean = false;
  esNuevaObs: boolean = false;
  dataResourceObs: any[];
  oTraspasos: any[];
  idTraspasoDestino: number = 0;
  tipo_agregacion_id: number = 1;
  tdfId: number = 0;
  idFuente: number = 0;
  idOrganismo: number = 0;
  tdfFuente: any = {
    idTdf: 0,
    idFuente: 0,
    idOrganismo: 0
  };
  dataResourceLT: any[];
  popupVisibleListTraspasos = false;
  popupVisibleEditFuente = false;
  dataResourceFF: any[];
  dataResourceOF: any[];
  scrollByContent = true;
  scrollByThumb = true;
  estados: any = [];
  dataResource: any[];
  dataPartidas: any[];
  //dataIntervenciones: any[];
  popupVisibleP: boolean = false;
  popupVisibleChk: boolean = false;
  popupVisibleEditarF: boolean = false;
  popupVisibleO: boolean = false;
  baseUrl: string;
  traspaso_id: number;
  estado_id: number;
  estado_id_grid: number;
  model: any = {
    id: '',
    tipo_traspaso: '',
    estado_id: '',
    descripcion: '',
    hr: '',
    fecha_aprobacion: '',
    observacion_id: 0
  }
  tipoTraspaso: any = [
    { id: 2, text: 'Traspasos Destino (A)' },
    { id: 1, text: 'Traspasos Origen (De)' },
  ];
  dataResourceAgreacion: any[];
  tipoSeg: any = [];
  ttId: number;
  ttra: number;
  rol: number = 0;
  fechaAprob: any = new Date();
  hasError: any;
  tipo_traspaso_id: number;
  popupVisibleRT: boolean = false;
  
  constructor(private _gs: GeneralService, private _trs: TraspasoService, private _fss: FuenteService, private _ofs: OrganismoService, private _ts: PoaTechoService) {
    let u = JSON.parse(localStorage.getItem('u'));

    this.rol = u.rol;
    this.tipo_agregacion_id = 1;

    this.baseUrl = environment.apiEndpoint;
    this.ttId = 2;
    this.ttra = 2;
    this.estado_id = 21;
    this.getTipoAgregacion();
    this.getTraspasos();
    this.getEstadosTByUsuario();


    //this.getEstadosTByUsuarioSeguimiento(this.ttra, this.tipo);

  }

  ngOnInit() {
  }

  getTraspasos() {

    this._trs.getTraspasosPorAprobar(this.ttId, this.estado_id, this.tipo_agregacion_id).subscribe((response) => {
      let result = UtilHelper.responses(response);
      if (result.status == 200) {
        this.ttra = this.ttId;
        this.dataResource = result.data;

      } else {
        this.dataResource = [];
      }
    },
      (error) => { console.log('Error', error); });
  }

  refreshDataGrid(e) {
    this.estado_id = e.value;
    this.getTraspasos();
    this.dataGrid.instance.refresh();
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  getTipoAgregacion() {
    this._ts.getTipoAgregacion().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {

          this.dataResourceAgreacion = result.data;

        } else {
          this.dataResourceAgreacion = [];
        }
      },
      (error) => { console.log('Error', error); });
  }

  showModalPartidas(id: number) {
    this.getPartidasTraspasoById(id, this.ttId == 1 ? 'O' : 'D');
    this.popupVisibleP = true;
  }

  savePartidas() {
    if (this.validCantidades()) {
      this._trs.putCantidadesPreciosByTraspaso({ data: this.dataPartidas }).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getTraspasos();
            this.popupVisibleP = false;
            toastr.success('Operación realizada exitosamente.');
          }
        },
        error => { console.log('Error', error); });
    }
  }

  // validCantidades() {
  //   let r = true, f1 = false, f2 = false, puf = 0, cf = 0, sf = 0, auxF = 0, put = 0, ct = 0, st = 0, auxT = 0, f3 = false;

  //   this.dataPartidas.forEach(item => {
  //     put = parseFloat(item.precio_unitario_t);
  //     ct = parseFloat(item.cantidad_t);
  //     st = parseFloat(item.monto);
  //     auxT = Math.fround(put * ct) * 100 / 100;

  //     puf = parseFloat(item.precio_unitario_f);
  //     cf = parseFloat(item.cantidad_f);
  //     sf = parseFloat(item.saldo);
  //     auxF = Math.fround(puf * cf) * 100 / 100;

  //     if ((item.cantidad_t == 0) || (item.precio_unitario_t == 0) || (item.precio_unitario_f < 0) || (item.cantidad_f < 0))
  //       f1 = true;
  //     if ((auxT > st) || (auxF > sf) || (puf * 1) > sf || (cf * 1) > sf)
  //       f2 = true;
  //     if ((sf != 0) && (auxF == 0))
  //       f3 = true;
  //   });

  //   if (f1) {
  //     r = false;
  //     toastr.warning('Complete los datos...');
  //   }
  //   if (f2) {
  //     r = false;
  //     toastr.warning('El precio unitario * el monto no debe ser mayor al saldo y monto liberado');
  //   }
  //   if (f3) {
  //     r = false;
  //     toastr.warning('La cantidad y precio unitario Formulado es diferenre al total formulado ');
  //   }
  //   return r;
  // }

  validCantidades() {
    let r = true, f1 = false, f2 = false, puf = 0, cf = 0, sf = 0, auxF = 0, put = 0, ct = 0, st = 0, auxT = 0, f3 = false;

    this.dataPartidas.forEach(item => {
      put = parseFloat(item.precio_unitario_t);
      ct = parseFloat(item.cantidad_t);
      st = parseFloat(item.monto);
      var auxA = put * ct;
      auxT = (Math.floor(auxA * Math.pow(10, 2)) / Math.pow(10, 2));
      puf = parseFloat(item.precio_unitario_f);
      cf = parseFloat(item.cantidad_f);
      sf = parseFloat(item.saldo);
      var auxFF = puf * cf;
      auxF = (Math.floor(auxFF * Math.pow(10, 2)) / Math.pow(10, 2));
      if ((item.cantidad_t == 0) || (item.precio_unitario_t == 0) || (item.precio_unitario_f < 0) || (item.cantidad_f < 0))
        f1 = true;
      if ((auxT > st) || (auxF > sf) || (puf * 1) > sf || (cf * 1) > sf)
        f2 = true;
      if ((sf != 0) && (auxF == 0))
        f3 = true;
    });

    if (f1) {
      r = false;
      toastr.warning('Complete los datos...');
    }
    if (f2) {
      r = false;
      toastr.warning('El precio unitario * el monto no debe ser mayor al saldo y monto liberado');
    }
    if (f3) {
      r = false;
      toastr.warning('La cantidad y precio unitario Formulado es diferenre al total formulado ');
    }
    return r;
  }

  showModalCheck(id: number, t_traspaso: string, estado_id: number) {
    this.estado_id_grid = estado_id;
    this.model.id = id;
    this.model.tipo_traspaso = '';
    this.model.estado_id = '';
    this.model.descripcion = '';
    this.model.hr = '';
    this.model.fecha_aprobacion = '';
    this.resetErrors();
    this.popupVisibleChk = true;
    if (t_traspaso == 'Fisico') {
      this.tipo_traspaso_id = 6;
    }
    else
      this.tipo_traspaso_id = 4;
    this.getEstadosTByUsuarioSeguimiento(this.ttra, this.tipo_traspaso_id);
    this.verListaObs = false;
  }

  aprobarTraspaso() {
    this.model.tipo_traspaso = this.ttId == 1 ? 'O' : 'D';
    this.model.fecha_aprobacion = this.fechaAprob == null ? '' : this.formatDate(this.fechaAprob);
    this.resetErrors();
    if (this.valid()) {
      if ((this.tipo_traspaso_id == 6) && (this.estado_id_grid == 21) && (this.model.estado_id == 22)) {
        toastr.warning('De cambiar el estado a Revisado previamente a ser Aprobado');
      } else if ((this.tipo_traspaso_id == 6) && (this.estado_id_grid == 22) && (this.model.estado_id == 38)) {
        toastr.warning('No se puede cambiar el estado a: REVISADO DGP un Traspaso que ya se encuentra APROBADO');
      } else if (this.model.estado_id == this.estado_id_grid) {
        toastr.warning('Elija un estado diferente al Actual',);
      }
      else {
        this._trs.putSeguimientoGral(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getTraspasos();
              this.popupVisibleChk = false;
              this.verListaObs = false;
              toastr.success('Operación realizada exitosamente.');
            }
            else {
              this.getTraspasos();
              this.popupVisibleChk = false;
              toastr.success('Ocurrió algún error al actualizar');
            }
          },
          error => { console.log('Error', error); });
      }
    }
  }

  getEstadosTByUsuario() {
    this._trs.getEstadosTByUsuario().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.estados = result.data;
        }
        else { this.estados = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getEstadosTByUsuarioSeguimiento(ttraId: number, tTraspaso: number) {
    this._trs.getEstadosTByUsuarioSeguimiento(ttraId, tTraspaso).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.tipoSeg = result.data;
        }
      });
  }

  getPartidasTraspasoById(id: number, tipo: string) {
    this._trs.getPartidasTraspasoById(id, tipo).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataPartidas = result.data;
        }
      });
  }

  valid() {
    let res = true;
    if (!UtilHelper.validator(this.model.estado_id, 0)) {
      this.hasError.estado_id = true; res = false;
    }
    if (!UtilHelper.validator(this.model.descripcion, 'text')) {
      this.hasError.descripcion = true; res = false;
    }
    if ((this.tipo_traspaso_id != 6 && this.model.estado_id == 24) || (this.tipo_traspaso_id == 6 && this.model.estado_id == 22)) {
      if (!UtilHelper.validator(this.model.hr, 'text')) {
        this.hasError.hr = true; res = false;
        toastr.warning('Ingrese el número de Hoja de Ruta');
      }
      if (!UtilHelper.validator(this.model.fecha_aprobacion, 'text')) {
        this.hasError.fecha_aprobacion = true; res = false;
        toastr.warning('Elija la fecha de aprobación');
      }
    }
    if (this.model.estado_id == 23 || this.model.estado_id == 29) {
      if (this.model.observacion_id == 0) {
        this.hasError.observacion_id = true; res = false;
      }
    }
    return res;
  }

  resetErrors() {
    this.hasError = { estado_id: false, descripcion: false, hr: false, fecha_aprobacion: false, observacion_id: false };
  }

  public formatDate(date) {
    var month = '' + (date.getMonth() + 1),
      day = '' + date.getDate(),
      year = date.getFullYear();
    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;
    return [year, month, day].join('-');
  }

  public getModelDesc() {

    if ((this.model.estado_id == 22) || (this.model.estado_id == 24) || (this.model.estado_id == 38)) {
      this.esNuevaObs = true;
      this.model.descripcion = 'Ninguna';
      this.verListaObs = false;
    }
    else {
      this.getObservacionesLista();
      this.esNuevaObs = false;
      this.model.descripcion = '';
      this.model.observacion_id = 0;
      this.verListaObs = true;
    }
  }



  getFuente() {
    this._fss.getFuentesVigentes().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceFF = result.data;
        } else {
          this.dataResourceFF = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  getOrganismo() {
    this._ofs.getOrganismoVigentes().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceOF = result.data;
        } else {
          this.dataResourceOF = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  saveFuente() {
    this.tdfFuente.idTdf = this.tdfId;
    this.tdfFuente.idFuente = this.idFuente;
    this.tdfFuente.idOrganismo = this.idOrganismo;
    this._trs.putFuenteIdTDF(this.tdfFuente).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleEditFuente = false;
          this.getListPartidasTraspaso(this.idTraspasoDestino);
          toastr.success('Operación realizada exitosamente.');
        }
      },
      error => { console.log('Error', error); });
  }

  getIdFuente(e: any) {
    this.idFuente = e.value;
  }

  getIdOrganismo(e: any) {
    this.idOrganismo = e.value;
  }

  showEditFuente(id: any) {
    this.popupVisibleEditFuente = true;
    this.tdfId = id;
    this.getFuente();
    this.getOrganismo();
  }

  showListTraspaso(id: any) {
    this.idTraspasoDestino = id;
    this.getListPartidasTraspaso(id);
    this.popupVisibleListTraspasos = true;
  }

  getListPartidasTraspaso(id: number) {
    this._trs.getListPartidasTraspaso(id).subscribe(
      response => {
        let r = UtilHelper.responses(response);
        if (r.status == 200) {
          this.dataResourceLT = r.data;
        }
        else {
          //this.dataFuentes = [];         
        }
      },
      error => { console.log('Error', error); });
  }

  showModalObs(id: number) {
    this._trs.getTraspasoSeguimientoById({ id: id, tipo: this.ttId == 1 ? 'O' : 'D' }).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.oTraspasos = result.data;
        } else {
          this.oTraspasos = [];
        }
      });
    this.popupVisibleO = true;
  }


  getDescribirObservacion(e: any) {
    var esNueva = this.dataResourceObs.filter(o => o.id == e.value).map(o => o.descripcion).toString();
    if (esNueva == 'Otro') {
      this.model.descripcion = '';
      this.esNuevaObs = true;
    }

    else {
      this.esNuevaObs = false;
      this.model.descripcion = esNueva;
    }

  }

  getObservacionesLista() {
    this._gs.getObservaciones('TRASPASOS').subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceObs = result.data;
        }
        else { this.dataResourceObs = []; }
      },
      (error) => { console.log('Error', error); });
  }

  showModalRT(id: number) {
    this.model.id = id;    
    this.popupVisibleRT = true;   
  }

  putRevertirTraspasoDestino() {
    
    this._trs.revertirTraspasoDestino(this.model).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleRT = false;
          this.getTraspasos();
          toastr.success('Operación realizada exitosamente.');
        }
      },
      error => { console.log('Error', error); });


  }

}
